import { Typography } from "antd";
import PropTypes from "prop-types";

function TrialMessage({ msg }) {
  return <Typography className="login-trial-info">{msg}</Typography>;
}

TrialMessage.propTypes = {
  msg: PropTypes.string.isRequired,
};

export { TrialMessage };
